module.exports = __webpack_public_path__ + "static/media/ic_covid_b_3_myway.7f04dc30.svg";